/*
    封装axios
    请求拦截器
    响应拦截器
*/

import Axios from 'axios';
import store from '../store/index';
import router from '../router';

let url = process.env.VUE_APP_BASE_URL;
// 引入提示框
import {MessageBox} from 'element-ui';
import {Message} from 'element-ui';

const axios = Axios.create({
    baseURL: url, timeout: 10000, // request timeout
});

let showMsg = true; //阻止错误多次弹窗

// 添加请求拦截器  作用是在请求发送前进行一些操作
axios.interceptors.request.use(function (config) {
    console.log(config.url)
    // 获取存储token中的值
    let userinfo = store.state.userInfo.authToken || '';
    localStorage.setItem('Token', userinfo);
    // 如果有用户信息，就在请求前加token，我这里是接口返回两个token，所以判断了一下对应的接口加对应的token
    if (userinfo) {
        // /assetBase/info/scanQrCodeAssetH5Info  对扫描进入二维码页面进行处理
        if (config.url === '/assetBase/info/scanQrCodeAssetH5Info' || config.url === '/index/appletBanner' || config.url === '/index/companyIntroduce' || config.url === '/index/companyNews' || config.url === '/index/companyProduct' || config.url === '/index/companyContact') {
        } else {
            config.headers.Authorization = userinfo;
        }
    }
    return config;
}, function (error) {
    // 抛出错误
    Message.error('请求中错误:' + error);
    // 对请求错误做些什么
    return Promise.reject(error);
});

// 添加响应拦截器  作用是在接收到响应后进行一些操作
axios.interceptors.response.use(function (response) {
    // 对响应数据做点什么
    if (response.status == 200) {
        if (showMsg) {
            if (response.data.code === 4040) {
                Message.error('登录过期！请重新登陆');
                store.commit("removeUserInof");
                router.push({
                    path: '/',
                });
            }
            showMsg = false;
            setTimeout(() => {
                showMsg = true;
            }, 3000);
        }
    } else {
        // 获取成功后的错误提示
        MessageBox.alert('系统错误', '错误2', {
            confirmButtonText: '确定', type: 'error',
        });
    }

    return response;
}, function (error) {
    // 在这里还可以进行响应码的判断
    switch (error.response.status) {
        case 4040:
            Message.error('登录过期！请重新登陆');
            localStorage.clear();
            store.commit("removeUserInof");
            localStorage.removeItem('path');
            router.push({
                path: '/',
            });
            break;
        case 500:
            error.message = '服务器端出错';
            break;
    }
    // 抛出错误提示
    MessageBox.alert(error, '错误3', {
        confirmButtonText: '确定', type: 'error',
    });
    // 对响应错误做点什么
    return Promise.reject(error);
});
export default axios
